import {
  Box,
  Center,
  createIcon,
  Flex,
  Heading,
  Icon,
  Stack,
  Text,
  useColorModeValue,
  Button,
  Image,
  Container,
  border,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { AiOutlineInstagram } from "react-icons/ai";
import { FaLinkedin, FaTiktok } from "react-icons/fa";
import { IoLogoPinterest } from "react-icons/io5";
import { RiFacebookFill, RiTwitterFill } from "react-icons/ri";
import { FaShopify } from "react-icons/fa";
import Meta from "../data/Meta.png";
import MarketingPartner from "../data/MarketingPartner.png";
import Partners from "../data/Partners.png";
import PricingBG from "../data/PricingBG.png";
import PriceTag from "./PricingComponents579/priceTag";
import BlueBox659 from "../Components/BlueBox659";
import { Footer } from "../Components/Footer";
import PricingBlock579 from "./PricingComponents579/PricingBlock579";

export const Pricing579 = () => {
  const [substype, setsubstype] = useState("year");

  const changeSubscription = (val) => {
    setsubstype(val);
  };
  return (
    <Container maxWidth={"full"} alignItems={"center"}>
      <Center mt={"8rem"}>
        <Flex direction={"column"}>
          <Box fontSize={["xx-small", "md", "lg", "4xl"]} mb={"2rem"}>
            <Heading as="h2" size="2xl">
              Publish Flawlessly.
            </Heading>
            <Heading as="h2" size="2xl">
              Analyze Effortlessly. Engage Authentically.
            </Heading>
          </Box>

          <Text>
            We've built simpler social media tools for busy people. Enjoy our
            free plan as you get started, or trial our full toolkit priced to
            make marketing your business on social affordable.
          </Text>
          <Stack
            direction={"row"}
            spacing={-0}
            align={"center"}
            alignSelf={"center"}
            position={"relative"}
            margin={"30px"}
          >
            <Button
              colorScheme={"blue"}
              variant="outline"
              rounded={"0px"}
              px={6}
              style={{
                border: `${
                  substype === "month" ? "2px solid blue" : "1px solid blue"
                }`,
              }}
              onClick={() => changeSubscription("month")}
            >
              Monthly
            </Button>
            <Button
              variant={"outline"}
              colorScheme={"blue"}
              rounded={"0px"}
              style={{
                border: `${
                  substype === "year" ? "2px solid blue" : "1px solid blue"
                }`,
              }}
              onClick={() => changeSubscription("year")}
            >
              Yearly
            </Button>
            <Box>
              <Icon
                as={Arrow}
                color={useColorModeValue("gray.800", "gray.300")}
                w={71}
                position={"absolute"}
                right={-71}
                top={"10px"}
              />
              <Text
                fontSize={"lg"}
                fontFamily={"Caveat"}
                position={"absolute"}
                right={"-125px"}
                top={"-15px"}
                transform={"rotate(10deg)"}
              >
                Gets 2 monthes free
              </Text>
            </Box>
          </Stack>
          <Flex
            direction={"row"}
            fontSize={"25px"}
            gap="20px"
            marginBottom={"20px"}
            margin="auto"
          >
            <AiOutlineInstagram></AiOutlineInstagram>
            <RiFacebookFill></RiFacebookFill>
            <RiTwitterFill></RiTwitterFill>
            <FaTiktok></FaTiktok>
            <FaLinkedin></FaLinkedin>
            <FaShopify />
            <IoLogoPinterest></IoLogoPinterest>
          </Flex>
        </Flex>
      </Center>

      <Center>
        <Box margin={"50px auto"} width={"100%"}>
          <Box
            maxW={"100%"}
            h={["2100px", "2100px", "1200px", "1200px", "400px"]}
            // border={"2px solid green"}
            position="absolute"
            bgImg={PricingBG}
            zIndex={-1}
            mt={"8rem"}
            bgSize="cover"
          >
            <Image src={PricingBG} w="100%"></Image>
          </Box>
          <PriceTag substype={substype}></PriceTag>
        </Box>
      </Center>

      <Flex
        direction={"row"}
        alignItems="center"
        justifyContent={"center"}
        margin={"4rem"}
      >
        <Image src={Meta}></Image>
        <Image src={Partners}></Image>
        <Image src={MarketingPartner}></Image>
      </Flex>
      <Center>
        <Heading as="h2" size="xl">
          Compare our plans side-by-side
        </Heading>
      </Center>
      <PricingBlock579></PricingBlock579>

      <BlueBox659></BlueBox659>
    </Container>
  );
};

const Arrow = createIcon({
  displayName: "Arrow",
  viewBox: "0 0 72 24",
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.600904 7.08166C0.764293 6.8879 1.01492 6.79004 1.26654 6.82177C2.83216 7.01918 5.20326 7.24581 7.54543 7.23964C9.92491 7.23338 12.1351 6.98464 13.4704 6.32142C13.84 6.13785 14.2885 6.28805 14.4722 6.65692C14.6559 7.02578 14.5052 7.47362 14.1356 7.6572C12.4625 8.48822 9.94063 8.72541 7.54852 8.7317C5.67514 8.73663 3.79547 8.5985 2.29921 8.44247C2.80955 9.59638 3.50943 10.6396 4.24665 11.7384C4.39435 11.9585 4.54354 12.1809 4.69301 12.4068C5.79543 14.0733 6.88128 15.8995 7.1179 18.2636C7.15893 18.6735 6.85928 19.0393 6.4486 19.0805C6.03792 19.1217 5.67174 18.8227 5.6307 18.4128C5.43271 16.4346 4.52957 14.868 3.4457 13.2296C3.3058 13.0181 3.16221 12.8046 3.01684 12.5885C2.05899 11.1646 1.02372 9.62564 0.457909 7.78069C0.383671 7.53862 0.437515 7.27541 0.600904 7.08166ZM5.52039 10.2248C5.77662 9.90161 6.24663 9.84687 6.57018 10.1025C16.4834 17.9344 29.9158 22.4064 42.0781 21.4773C54.1988 20.5514 65.0339 14.2748 69.9746 0.584299C70.1145 0.196597 70.5427 -0.0046455 70.931 0.134813C71.3193 0.274276 71.5206 0.70162 71.3807 1.08932C66.2105 15.4159 54.8056 22.0014 42.1913 22.965C29.6185 23.9254 15.8207 19.3142 5.64226 11.2727C5.31871 11.0171 5.26415 10.5479 5.52039 10.2248Z"
      fill="currentColor"
    />
  ),
});
